import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';

import $ from 'jquery';
import { css } from 'glamor';
import { ToastContainer } from 'react-toastify';
import toast from '../toast';

//  ----------------   Custom components
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import RelayAnimation from '../RelayAnimation/RelayAnimation';
import { translate } from 'react-i18next';


class RemoteLogin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };

    this.notifySuccess = this.notifySuccess.bind(this);
    this.notifyError = this.notifyError.bind(this);
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  notifyError(msg) {
    toast.error(msg);
  }
  toggleLoader() {
    this.setState({
      loading: !this.state.loading
    });
  }


  validateReq() {
    const { q } = this.props.match.params;
    let query = atob(q);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        localStorage.setItem(decodeURIComponent(pair[0]), decodeURIComponent(pair[1]));
    }
    this.props.history.push('/dashboard');
  }

  render() {
    const validateReq = this.validateReq();
    return <b>Loading</b>;
  }
}

export default withRouter(translate('translations')(RemoteLogin));


// WEBPACK FOOTER //
// ./src/components/RemoteLogin/RemoteLogin.js